import { Host } from '../utils';

// 其他页面埋点
export default function burialPointOther(pageId: string, replaceOriginPageId: string, host?: Host): void {
    // let newObj: any = {
    //     user: {
    //         userType: '1',
    //         serviceType: 'C',
    //         clientType: store.status.gameApp ? 3 : 4,
    //         osTypeId: _equipmentType(),
    //         appId: store.status.gameId ? store.status.gameId : ''
    //     },
    //     page: {
    //         pageId: pageId,
    //         originPageId: getUrlParam('originPageId') || replaceOriginPageId
    //     }
    // };
    //
    // post('burialpoint/logOther', {body: JSON.stringify(newObj)}).then((rd) => {
    // });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/burialPointOther.ts